import './PersonalSharePanel.scss';
import React from 'react';
import Modal from 'antd/lib/modal/Modal';
import { PersonalSceneTab } from './personal-scene-tab/PersonalSceneTab';
import { useSelector } from 'react-redux';
import { sceneNameSelector } from 'redux/slices/app/selectors';

export const SharePersonalSceneModal = ({ onClose = () => {} }) => {
  const sceneName = useSelector(sceneNameSelector);
  return (
    <Modal
      transitionName=""
      maskTransitionName=""
      className="personal-share-modal"
      title={`Share ${sceneName}`}
      visible
      onCancel={onClose}
      footer={null}
    >
      <PersonalSceneTab />
    </Modal>
  );
};
